function closeOpenMobileDrawers(event) {
  const target = event.target;
  if (!(target instanceof Node)) return;

  document.querySelectorAll('.malle-mobile-header .malle-header-drawer[open]').forEach((drawer) => {
    if (!drawer.contains(target)) {
      drawer.removeAttribute('open');
    }
  });
}

document.addEventListener('pointerdown', closeOpenMobileDrawers);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.malle-mobile-header .malle-header-drawer[open]').forEach((drawer) => {
    drawer.removeAttribute('open');
  });
});
